export const uiMutationTypes = {
  ADD_RANGE_DATE: 'ADD_RANGE_DATE',
  ADD_CHANNEL: 'ADD_CHANNEL',
  ADD_TAB_NAME: 'ADD_TAB_NAME',
  ADD_GROUP_LIST: 'ADD_GROUP_LIST',
};
